function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M117.479 68H146.399C144.399 73.84 140.289 78.14 135.669 81.91C131.049 85.68 125.599 87.73 119.769 88.91C117.769 89.33 117.459 88.63 117.479 86.91C117.529 80.62 117.489 74.31 117.479 68Z",
  fill: "#BDC7F8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.966 59.0005H42.546C42.2404 58.9932 41.9397 59.0789 41.6838 59.2462C41.4279 59.4134 41.2288 59.6545 41.1129 59.9373C40.9969 60.2202 40.9695 60.5316 41.0344 60.8304C41.0992 61.1291 41.2532 61.4012 41.476 61.6105L47.886 67.9605C48.0966 68.172 48.3651 68.3164 48.6577 68.3753C48.9503 68.4343 49.2538 68.4052 49.5299 68.2918C49.8059 68.1784 50.0422 67.9857 50.2088 67.7381C50.3754 67.4904 50.4649 67.199 50.466 66.9005L50.516 60.5205C50.5174 60.318 50.4781 60.1172 50.4003 59.9302C50.3225 59.7432 50.2079 59.5737 50.0633 59.4319C49.9187 59.2901 49.747 59.1788 49.5585 59.1047C49.37 59.0306 49.1685 58.9952 48.966 59.0005V59.0005Z",
  fill: "#BDC7F8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M50.0001 3.57051V18.6805C49.995 19.3895 50.2017 20.0839 50.5938 20.6747C50.9858 21.2655 51.5454 21.7258 52.2007 21.9965C52.8561 22.2672 53.5773 22.3361 54.272 22.1943C54.9668 22.0525 55.6033 21.7064 56.1001 21.2005L71.1001 6.20051C71.6042 5.7055 71.9495 5.07171 72.0923 4.37981C72.235 3.68791 72.1687 2.96918 71.9017 2.3151C71.6347 1.66102 71.1791 1.10116 70.593 0.706796C70.0068 0.312427 69.3166 0.101378 68.6101 0.100507L53.6101 0.000508122C53.1372 -0.00749368 52.6675 0.0790844 52.2285 0.255158C51.7895 0.431232 51.3901 0.693248 51.0538 1.02582C50.7175 1.3584 50.4511 1.75482 50.2701 2.19181C50.0892 2.6288 49.9974 3.09754 50.0001 3.57051V3.57051Z",
  fill: "#BDC7F8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3 173.5H51.5C51.5 152.237 34.263 135 13 135H0V170.5C0 172.157 1.34315 173.5 3 173.5Z",
  fill: "#BDC7F8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M85 93H114C116.209 93 118 94.7909 118 97V124.731C118 125.432 117.432 126 116.731 126V126C99.2064 126 85 111.794 85 94.2692V93Z",
  fill: "#BDC7F8"
});

var SvgOrnamentLeft = function SvgOrnamentLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 174,
    viewBox: "0 0 147 174",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrnamentLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ornament-left.fa486ee4.svg";
export { ForwardRef as ReactComponent };